import React from 'react';
import { Flex } from '@chakra-ui/react';

export default function Legend({ children }) {
  return <Flex align="center">{children}</Flex>;
}
